// Note: vue-web-speech may not be compatible with Vue 3
// Consider using native Web Speech API or a Vue 3 compatible library
export default defineNuxtPlugin((nuxtApp) => {
    // TODO: Replace with Vue 3 compatible speech library or use native Web Speech API
    // nuxtApp.vueApp.use(VueSpeech)
})
